module.exports = __webpack_public_path__ + "img/ico-sendmoney-off-copy.7ad10189.svg";